module.exports = __webpack_public_path__ + "static/img/tiktok.d83285b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiktok.png
// module id = Zwx2
// module chunks = 1